import React from "react";
import { useNavigate } from "react-router-dom";
import { loadPage } from "../../utils/urlUtils";

export default function Error() {

    const CONF= window?.confPub;
    const ROUTES_PAGES = CONF?.ROUTES?.PAGES;

    const navigate = useNavigate()

    return (<>
        {/*<div className="d-flex justify-content-center align-items-baseline">*/ }
        <div className="d-flex justify-content-center align-items-end">
            <h1 className="m-0">Erreur</h1>
            <img
                className="w-25"
                src="../cat2.png"
                alt=""
            />
        </div>
        <div className="d-flex justify-content-center mt-4">
            <button type="submit" className="btn btn-primary center"
                onClick={ () => {
                    loadPage(navigate, ROUTES_PAGES?.ROOT)
                } }>Accueil
            </button>
        </div>
    </>)
}